import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Email from "@material-ui/icons/Email";
import Facebook from "@material-ui/icons/Facebook";

const ContactUs = () => (
  <div>
    <Typography variant="h6" color="inherit" gutterBottom>
      Contacto
    </Typography>
    <Box display="flex" alignItems="center" mb={1}>
      <Email fontSize="small" />
      <Link
        href="mailto:info@dashport.run"
        color="inherit"
        style={{ marginLeft: 8 }}
      >
        info@dashport.run
      </Link>
    </Box>
    <Box display="flex" alignItems="center">
      <Facebook fontSize="small" />
      <Link
        href="https://www.facebook.com/dashportrun/"
        target="_blank"
        rel="noreferrer"
        color="inherit"
        style={{ marginLeft: 8 }}
      >
        Facebook Dashportrun
      </Link>
    </Box>
  </div>
);

export default ContactUs;
